import React, { useId } from 'react';
import SearchableMultiSelect from '../SearchableMultiSelect';
import { AppFilterField } from './AppFilterBar';

/**
 * Select de filtre.
 * - multiple=true (défaut) : plusieurs valeurs, cases à cocher
 * - multiple=false : une seule valeur, un nouveau clic remplace l’ancienne
 * value: string[] ; onChange: (next: string[]) => void
 */
export default function AppFilterSelect({
  id,
  label,
  value = [],
  onChange,
  options = [],
  placeholder = 'Tous',
  emptyLabel = 'Aucun résultat',
  disabled = false,
  searchable = true,
  multiple = true,
  col = 'col-6 col-md-3 col-lg-2',
  className = '',
}) {
  const autoId = useId();
  const fieldId = id || autoId;
  const selected = Array.isArray(value) ? value : (value ? [String(value)] : []);

  return (
    <AppFilterField col={col} label={label} htmlFor={fieldId} className={className}>
      <SearchableMultiSelect
        id={fieldId}
        value={selected}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        emptyLabel={emptyLabel}
        disabled={disabled}
        searchable={searchable}
        multiple={multiple}
        hideCounter
        buttonClassName="form-select form-select-sm text-start"
      />
    </AppFilterField>
  );
}
